import {loginUrls, loginArr} from './loginUrl'

export const loginsUrls = [
  ...loginUrls
]

export const login = {
  loginArr
}



// WEBPACK FOOTER //
// ./src/api/gip/login/index.js